<template>
  <div class="survey-statistics">

<!--    <div class="row mb-4">
      <div class="col-md-12">
        <DateRangePicker
            id="dashboard-daterangepicker"
            @update:date="handleRangeDate"
        />
      </div>
    </div>-->

    <div class="row mt-10">
      <div class="col-md-6 ">
        <h1>{{ stats.survey_name }}</h1>
        <p class="fs-4">
          <strong class="fs-2"> {{ $t('qvct_survey.stats.period') }} : </strong>
          <span>{{ stats.start_date ? stats.start_date.substring(0, 10) : '-' }}</span>
          {{ $t('qvct_survey.stats.to') }}
          <span>{{ stats.end_date ? stats.end_date.substring(0, 10) : '...' }}</span>
        </p>
        <p class="fs-4">
          <strong class="fs-2">{{ $t('qvct_survey.stats.participants') }} : </strong> {{ stats.total_participants }}<br>
          <strong class="fs-2">{{ $t('qvct_survey.stats.responses') }} : </strong> {{ stats.total_responses }}<br>
          <strong class="fs-2">{{ $t('qvct_survey.stats.participation_rate') }} : </strong> {{ stats.total_participation_rate }}
        </p>
      </div>
      <div class="col-md-6">
        <p class="fs-4">
          <strong class="fs-2">{{ $t('qvct_survey.stats.analyzed_period') }}  : </strong>
          <span>{{ stats.date_range?.from }}</span>
          {{ $t('qvct_survey.stats.to') }}
          <span>{{ stats.date_range?.to }}</span>
        </p>
      </div>
    </div>

    <div class="table-responsive">
      <table
          class="table table-bordered table-hover"
          id="kt_datatable_survey_stats"
          style="margin-top: 13px !important; cursor: pointer"
      >
        <thead>
        <tr class="fw-bold fs-6" style="background-color: #F2F3F4">
          <th>{{ $t('qvct_survey.stats.date') }}</th>
          <th>{{ $t('qvct_survey.stats.daily_responses') }}</th>
          <th>{{ $t('qvct_survey.stats.daily_participation_rate') }}</th>
        </tr>
        </thead>
      </table>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch, nextTick } from "vue";
import { BASE_URL } from "@/services/api";
import Ls from "@/services/ls";
import { useLocales } from "@/composables/locales";
import DateRangePicker from "@/components/DateRangePicker.vue";

const props = defineProps({
  survey: {
    type: Object,
    required: true,
  },
  surveyStats: {
    type: Object,
    required: true,
  },
});

const stats = computed(() => props.surveyStats || {});
const table = ref(null);
const { locale, datatableLocaleUrl } = useLocales();

const dateRange = ref({
  start: null,
  end: null
});

onMounted(() => {
  initDatatable('kt_datatable_survey_stats');
});

watch(
    () => locale.value,
    () => {
      nextTick(() => initDatatable('kt_datatable_survey_stats'));
    }
);

function handleRangeDate(date) {
  dateRange.value = {
    start: date.start,
    end: date.end
  };
  refreshDatatable();
}

function refreshDatatable() {
  if (table.value) {
    table.value.ajax.reload();
  }
}

function initDatatable(tableId) {
  const AUTH_TOKEN = Ls.get("auth.token");
  const pageLimit = Ls.get("pageLength");

  if ($.fn.DataTable.isDataTable('#' + tableId)) {
    $('#' + tableId).DataTable().destroy();
  }

  table.value = $("#" + tableId).DataTable({
    destroy: true,
    responsive: true,
    searchDelay: 500,
    processing: true,
    serverSide: true,
    pageLength: pageLimit || 9,
    lengthMenu: [9, 10, 25, 50, 75, 100],
    order: [[0, 'desc']],
    ajax: {
      url: BASE_URL + "/get/qvct/survey/" + props.survey.id + "/participation/statistics",
      type: "GET",
      data: function (d) {
        if (dateRange.value.start) {
          d.start_date = dateRange.value.start;
        }
        if (dateRange.value.end) {
          d.end_date = dateRange.value.end;
        }
        return d;
      },
      beforeSend: function (request, options) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get("current.company"));
      },
    },
    columns: [
      { data: "formatted_date" },
      { data: "daily_responses" },
      { data: "daily_participation_rate", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -3,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' + t + "</span>";
        },
      },
      {
        targets: -2,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' + t + '</span>';
        },
      },
      {
        width: "15%",
        targets: -1,
        "className": "dt-center",
        orderable: !1,
        render: function (t, a, e, l) {
          return '<span>' + t + '</span>';
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    },
  });
}
</script>

<style scoped>
.survey-statistics {
  padding: 1rem;
}
.table th,
.table td {
  vertical-align: middle;
}

.date-filter {
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;
}
</style>